import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import Input from '../components/Input'
import Button from '../components/Button'
import Loading from '../components/Loading'
import { getRoleByID, updateRole } from '../actions/roleActions'
import {
  GET_ROLE_BY_ID_RESET,
  UPDATE_ROLE_RESET,
} from '../constants/roleConstants'

const RoleByID = ({ history }) => {
  let params = useParams()
  let id = ''
  if (params.id) {
    id = params.id.replace(':', '')
  }

  // * States
  const navigate = useNavigate();
  const [name, setName] = useState('')
  const [tasksView, setTasksView] = useState(false)
  const [tasksDetailsView, setTasksDetailsView] = useState(false)
  const [tasksUpdate, setTasksUpdate] = useState(false)
  const [tasksAddCustomer, setTasksAddCustomer] = useState(false)
  const [tasksAddAllocation, setTasksAddAllocation] = useState(false)
  const [allocationPendingTasks, setAllocationPendingTasks] = useState(false)
  const [visitPendingTasks, setVisitPendingTasks] = useState(false)
  const [inProgressTasks, setInProgressTasks] = useState(false)
  const [finalisationPendingTasks, setFinalisationPendingTasks] =
    useState(false)
  const [completedTasks, setCompletedTasks] = useState(false)
  const [waivedTasks, setWaivedTasks] = useState(false)
  const [calling, setCalling] = useState(false)
  const [taskSummary, setTaskSummary] = useState(false)
  const [transfers, setTransfers] = useState(false)
  const [usersView, setUsersView] = useState(false)
  const [usersAdd, setUsersAdd] = useState(false)
  const [usersUpdate, setUsersUpdate] = useState(false)
  const [rejoinUsers, setRejoinUsers] = useState(false)
  const [viewAttendance, setViewAttendance] = useState(false)
  const [viewUnassignTasks, setViewUnassignTasks] = useState(false)
  const [viewTransfferedTasks, setViewTransfferedTasks] = useState(false)
  const [viewFieldTasks, setViewFieldTasks] = useState(false)
  const [resignedUsers, setResignedUsers] = useState(false)
  const [rolesView, setRolesView] = useState(false)
  const [rolesAdd, setRolesAdd] = useState(false)
  const [rolesUpdate, setRolesUpdate] = useState(false)
  const [customersView, setCustomersView] = useState(false)
  const [customersAdd, setCustomersAdd] = useState(false)
  const [customersUpdate, setCustomersUpdate] = useState(false)
  const [appAccess, setAppAccess] = useState(false)
  const [webAccess, setWebAccess] = useState(false)
  const [settings, setSettings] = useState(false)
  const [reports, setReports] = useState(false)
  const [pincodes, setPincodes] = useState(false)
  const [dashboard, setDashboard] = useState(false)
  const [processView, setProcessView] = useState(false)
  const [processAdd, setProcessAdd] = useState(false)
  const [ProcessUpdate, setProcessUpdate] = useState(false)
  const [ProcessDelete, setProcessDelete] = useState(false)
  const [assignProcessView, setAssignProcessView] = useState(false)
  const [assignProcessAdd, setAssignProcessAdd] = useState(false)
  const [assignProcessUpdate, setAssignProcessUpdate] = useState(false)
  const [assignProcessDelete, setAssignProcessDelete] = useState(false)
  const [DailyCollectionView, setDailyCollectionView] = useState(false)
  const [DailyCollectionViewAdd, setDailyCollectionViewAdd] = useState(false)
  const [DailyCollectionViewUpdate, setDailyCollectionViewUpdate] = useState(false)
  const [DailyCollectionViewDelete, setDailyCollectionViewDelete] = useState(false)
  const [mis, setMis] = useState(false)
  const [driveNbfcDelhi, setDriveNbfcDelhi] = useState(false)
  const [driveNbfcHaryana, setDriveNbfcHaryana] = useState(false)
  const [driveNbfcUp, setDriveNbfcUp] = useState(false)
  const [driveNbfcTata, setDriveNbfcTata] = useState(false)
  const [driveHdfcCard, setDriveHdfcCard] = useState(false)
  const [driveHdfcRetail, setDriveHdfcRetail] = useState(false)
  const [driveIdfc, setDriveIdfc] = useState(false)
  const [driveKotak, setDriveKotak] = useState(false)
  const [verificationProcessView, setVerificationProcessView] = useState(false)
  const [verificationProcessAdd, setVerificationProcessAdd] = useState(false)
  const [verificationProcessUpdate, setVerificationProcessUpdate] = useState(false)
  const [verificationProcessDelete, setVerificationProcessDelete] = useState(false)
  const [assignVerificationProcessView, setAssignVerificationProcessView] = useState(false)
  const [assignVerificationProcessAdd, setAssignVerificationProcessAdd] = useState(false)
  const [assignVerificationProcessUpdate, setAssignVerificationProcessUpdate] = useState(false)
  const [assignVerificationProcessDelete, setAssignVerificationProcessDelete] = useState(false)
  const [verificationMisAdd, setVerificationMisAdd] = useState(false)
  const [verificationMisUpdate, setVerificationMisUpdate] = useState(false)
  const [verificationMisDelete, setVerificationMisDelete] = useState(false)
  const [verificationMisView, setVerificationMisView] = useState(false)
  const [verificationMisReport, setVerificationMisReport] = useState(false)
  const [driveHdfcCardUp, setDriveHdfcCardUp] = useState(false)
  const [driveHdfcRetailUp, setDriveHdfcRetailUp] = useState(false)
  const [exportRole, setExportRole] = useState(false)
  const [prospectForm, setProspectForm] = useState(false)
  // Salary Management Permissions
  const [companyView, setCompanyView] = useState(false)
  const [companyAdd, setCompanyAdd] = useState(false)
  const [companyUpdate, setCompanyUpdate] = useState(false)
  const [companyDelete, setCompanyDelete] = useState(false)
  const [salaryView, setSalaryView] = useState(false)
  const [salaryUpload, setSalaryUpload] = useState(false)
  const [salaryUpdate, setSalaryUpdate] = useState(false)
  const [salaryDelete, setSalaryDelete] = useState(false)
  const [salaryStats, setSalaryStats] = useState(false)
  const [advanceView, setAdvanceView] = useState(false)
  const [advanceUpload, setAdvanceUpload] = useState(false)
  const [advanceUpdate, setAdvanceUpdate] = useState(false)
  const [advanceDelete, setAdvanceDelete] = useState(false)
  const [attendanceView, setAttendanceView] = useState(false)
  const [attendanceUpload, setAttendanceUpload] = useState(false)
  const [attendanceUpdate, setAttendanceUpdate] = useState(false)
  const [attendanceDelete, setAttendanceDelete] = useState(false)
  const [attendanceStats, setAttendanceStats] = useState(false)
  const [bonusMaster, setBonusMaster] = useState(false)
  const [exportBankSheet, setExportBankSheet] = useState(false)
  const [salaryApproval, setSalaryApproval] = useState(false)
  const [accessCollectionType, setAccessCollectionType] = useState(false)
  const [accessVerificationType, setAccessVerificationType] = useState(false)
  const [accessStandardType, setAccessStandardType] = useState(false)
  // Supervisor Master Permissions
  const [supervisorMasterView, setSupervisorMasterView] = useState(false)
  const [supervisorMasterAdd, setSupervisorMasterAdd] = useState(false)
  const [supervisorMasterUpdate, setSupervisorMasterUpdate] = useState(false)
  const [supervisorMasterDelete, setSupervisorMasterDelete] = useState(false)
  // Billing Master Permissions
  const [billingMasterView, setBillingMasterView] = useState(false)
  const [billingMasterAdd, setBillingMasterAdd] = useState(false)
  const [billingMasterUpdate, setBillingMasterUpdate] = useState(false)
  const [billingMasterDelete, setBillingMasterDelete] = useState(false)
  const [billingMasterStatusUpdate, setBillingMasterStatusUpdate] = useState(false)
  // Provisional Billing Permissions
  const [provisionalBillingView, setProvisionalBillingView] = useState(false)
  const [provisionalBillingSubmit, setProvisionalBillingSubmit] = useState(false)
  const [provisionalBillingUpdate, setProvisionalBillingUpdate] = useState(false)
  const [provisionalBillingFillOnBehalf, setProvisionalBillingFillOnBehalf] = useState(false)
  // Distribution Permissions
  const [distributionView, setDistributionView] = useState(false)
  const [distributionAdd, setDistributionAdd] = useState(false)
  const [distributionUpdate, setDistributionUpdate] = useState(false)
  // Collection MIS Permissions
  const [collectionMisView, setCollectionMisView] = useState(false)
  const [collectionMisOverridePaid, setCollectionMisOverridePaid] = useState(false)
  // Employee Master Permissions
  const [employeeMasterView, setEmployeeMasterView] = useState(false)
  const [employeeMasterAdd, setEmployeeMasterAdd] = useState(false)
  const [employeeMasterUpdate, setEmployeeMasterUpdate] = useState(false)
  const [employeeMasterDelete, setEmployeeMasterDelete] = useState(false)
  const [employeeMasterMarkLeft, setEmployeeMasterMarkLeft] = useState(false)
  const [employeeMasterUpload, setEmployeeMasterUpload] = useState(false)
  const [employeeLeftView, setEmployeeLeftView] = useState(false)
  const [employeeLeftAdd, setEmployeeLeftAdd] = useState(false)
  const [employeeLeftUpdate, setEmployeeLeftUpdate] = useState(false)
  const [employeeLeftDelete, setEmployeeLeftDelete] = useState(false)
  const [employeeLeftRejoin, setEmployeeLeftRejoin] = useState(false)
  const [employeeLeftUpload, setEmployeeLeftUpload] = useState(false)
  // Current Month Only Restrictions
  const [advanceCurrentMonthOnly, setAdvanceCurrentMonthOnly] = useState(false)
  const [attendanceCurrentMonthOnly, setAttendanceCurrentMonthOnly] = useState(false)
  const [bonusCurrentMonthOnly, setBonusCurrentMonthOnly] = useState(false)
  // Verification Master Permissions
  const [priceMasterView, setPriceMasterView] = useState(false)
  const [priceMasterImport, setPriceMasterImport] = useState(false)
  const [priceMasterDelete, setPriceMasterDelete] = useState(false)
  const [reimbursementMasterView, setReimbursementMasterView] = useState(false)
  const [reimbursementMasterImport, setReimbursementMasterImport] = useState(false)
  const [reimbursementMasterDelete, setReimbursementMasterDelete] = useState(false)
  const [caseMasterView, setCaseMasterView] = useState(false)
  const [caseMasterImport, setCaseMasterImport] = useState(false)
  const [caseMasterDelete, setCaseMasterDelete] = useState(false)
  const [penaltyMasterView, setPenaltyMasterView] = useState(false)
  const [penaltyMasterImport, setPenaltyMasterImport] = useState(false)
  const [penaltyMasterDelete, setPenaltyMasterDelete] = useState(false)
  const [conveyanceMasterView, setConveyanceMasterView] = useState(false)
  const [conveyanceMasterImport, setConveyanceMasterImport] = useState(false)
  const [conveyanceMasterDelete, setConveyanceMasterDelete] = useState(false)
  const [verificationReportView, setVerificationReportView] = useState(false)
  const [verificationReportGenerate, setVerificationReportGenerate] = useState(false)
  const [verificationReportExport, setVerificationReportExport] = useState(false)
  const [verificationReportEdit, setVerificationReportEdit] = useState(false)
  const [consolidatedMisView, setConsolidatedMisView] = useState(false)
  const [consolidatedMisExport, setConsolidatedMisExport] = useState(false)

  const [loading, setLoading] = useState(true)

  // * Tasks
  const tasksAddByCustomer = () => {
    setTasksAddCustomer(true)
    setTasksAddAllocation(false)
  }

  const tasksAddByAllocator = () => {
    setTasksAddCustomer(false)
    setTasksAddAllocation(true)
  }

  const noTasksView = () => {
    setTasksView(false)
    setAllocationPendingTasks(false)
    setVisitPendingTasks(false)
    setInProgressTasks(false)
    setFinalisationPendingTasks(false)
    setCompletedTasks(false)
    setTaskSummary(false)
  }

  // * Initialization
  const dispatch = useDispatch()

  // * Check for auth
  const userLogin = useSelector((state) => state.userLogin)
  const { loadingUserInfo, userInfo } = userLogin

  useEffect(() => {
    if (!userInfo) {
      navigate('/')
    }
  }, [userInfo, history])

  // * Check for role
  const getRoleInfo = useSelector((state) => state.getRoleInfo)
  const { loadingGetRole, getRoleData } = getRoleInfo

  useEffect(() => {
    if (getRoleData) {
      if (!getRoleData.rolesUpdate) {
        toast('Not Authorized', {
          type: 'error',
          hideProgressBar: true,
          autoClose: 2000,
        })
        navigate('/')
      }
    }
  }, [userInfo, getRoleData, history])

  useEffect(() => {
    dispatch(getRoleByID(id))
  }, [])

  // * Get Role By ID
  const getRoleByIDInfo = useSelector((state) => state.getRoleByIDInfo)
  const { loadingGetRoleByIDInfo, errorGetRoleByIDInfo, getRoleByIDData } =
    getRoleByIDInfo

  useEffect(() => {
    dispatch({ type: GET_ROLE_BY_ID_RESET })
    if (getRoleByIDData) {
      setLoading(false)
      setName(getRoleByIDData.name)
      setTasksView(getRoleByIDData.tasksView)
      setTasksUpdate(getRoleByIDData.tasksUpdate)
      setTasksDetailsView(getRoleByIDData.tasksDetailsView)
      setTasksAddCustomer(getRoleByIDData.tasksAddCustomer)
      setTasksAddAllocation(getRoleByIDData.tasksAddAllocation)
      setAllocationPendingTasks(getRoleByIDData.allocationPendingTasks)
      setVisitPendingTasks(getRoleByIDData.visitPendingTasks)
      setInProgressTasks(getRoleByIDData.inProgressTasks)
      setFinalisationPendingTasks(getRoleByIDData.finalisationPendingTasks)
      setCompletedTasks(getRoleByIDData.completedTasks)
      setWaivedTasks(getRoleByIDData.waivedTasks)
      setCalling(getRoleByIDData.calling)
      setTaskSummary(getRoleByIDData.taskSummary)
      setTransfers(getRoleByIDData.transfers)
      setUsersView(getRoleByIDData.usersView)
      setUsersAdd(getRoleByIDData.usersAdd)
      setUsersUpdate(getRoleByIDData.usersUpdate)
      setViewAttendance(getRoleByIDData.viewAttendance)
      setRejoinUsers(getRoleByIDData.rejoinUsers)
      setViewFieldTasks(getRoleByIDData.viewFieldTasks)
      setViewUnassignTasks(getRoleByIDData.viewUnassignTasks)
      setResignedUsers(getRoleByIDData.resignedUsers)
      setRolesView(getRoleByIDData.rolesView)
      setRolesAdd(getRoleByIDData.rolesAdd)
      setRolesUpdate(getRoleByIDData.rolesUpdate)
      setCustomersView(getRoleByIDData.customersView)
      setCustomersAdd(getRoleByIDData.customersAdd)
      setCustomersUpdate(getRoleByIDData.customersUpdate)
      setAppAccess(getRoleByIDData.appAccess)
      setWebAccess(getRoleByIDData.webAccess)
      setSettings(getRoleByIDData.settings)
      setReports(getRoleByIDData.reports)
      setPincodes(getRoleByIDData.pincodes)
      setDashboard(getRoleByIDData.dashboard)
      setProcessView(getRoleByIDData.processView)
      setProcessAdd(getRoleByIDData.processAdd)
      setProcessUpdate(getRoleByIDData.ProcessUpdate)
      setProcessDelete(getRoleByIDData.ProcessDelete)
      setAssignProcessView(getRoleByIDData.assignProcessView)
      setAssignProcessAdd(getRoleByIDData.assignProcessAdd)
      setAssignProcessUpdate(getRoleByIDData.assignProcessUpdate)
      setAssignProcessDelete(getRoleByIDData.assignProcessDelete)
      setDailyCollectionView(getRoleByIDData.DailyCollectionView)
      setDailyCollectionViewAdd(getRoleByIDData.DailyCollectionViewAdd)
      setDailyCollectionViewUpdate(getRoleByIDData.DailyCollectionViewUpdate)
      setDailyCollectionViewDelete(getRoleByIDData.DailyCollectionViewDelete)
      setMis(getRoleByIDData.mis)
      setDriveNbfcDelhi(getRoleByIDData.driveNbfcDelhi)
      setDriveNbfcHaryana(getRoleByIDData.driveNbfcHaryana)
      setDriveNbfcUp(getRoleByIDData.driveNbfcUp)
      setDriveNbfcTata(getRoleByIDData.driveNbfcTata)
      setDriveHdfcCard(getRoleByIDData.driveHdfcCard)
      setDriveHdfcRetail(getRoleByIDData.driveHdfcRetail)
      setDriveIdfc(getRoleByIDData.driveIdfc)
      setDriveKotak(getRoleByIDData.driveKotak)
      setVerificationProcessView(getRoleByIDData.verificationProcessView)
      setVerificationProcessAdd(getRoleByIDData.verificationProcessAdd)
      setVerificationProcessUpdate(getRoleByIDData.verificationProcessUpdate)
      setVerificationProcessDelete(getRoleByIDData.verificationProcessDelete)
      setAssignVerificationProcessView(getRoleByIDData.assignVerificationProcessView)
      setAssignVerificationProcessAdd(getRoleByIDData.assignVerificationProcessAdd)
      setAssignVerificationProcessUpdate(getRoleByIDData.assignVerificationProcessUpdate)
      setAssignVerificationProcessDelete(getRoleByIDData.assignVerificationProcessDelete)
      setVerificationMisAdd(getRoleByIDData.verificationMisAdd)
      setVerificationMisUpdate(getRoleByIDData.verificationMisUpdate)
      setVerificationMisDelete(getRoleByIDData.verificationMisDelete)
      setVerificationMisView(getRoleByIDData.verificationMisView)
      setVerificationMisReport(getRoleByIDData.verificationMisReport)
      setDriveHdfcCardUp(getRoleByIDData.driveHdfcCardUp)
      setDriveHdfcRetailUp(getRoleByIDData.driveHdfcRetailUp)
      setExportRole(getRoleByIDData.export)
      setProspectForm(getRoleByIDData.prospectForm)
      setCompanyView(getRoleByIDData.companyView)
      setCompanyAdd(getRoleByIDData.companyAdd)
      setCompanyUpdate(getRoleByIDData.companyUpdate)
      setCompanyDelete(getRoleByIDData.companyDelete)
      setSalaryView(getRoleByIDData.salaryView)
      setSalaryUpload(getRoleByIDData.salaryUpload)
      setSalaryUpdate(getRoleByIDData.salaryUpdate)
      setSalaryDelete(getRoleByIDData.salaryDelete)
      setSalaryStats(getRoleByIDData.salaryStats)
      setAdvanceView(getRoleByIDData.advanceView)
      setAdvanceUpload(getRoleByIDData.advanceUpload)
      setAdvanceUpdate(getRoleByIDData.advanceUpdate)
      setAdvanceDelete(getRoleByIDData.advanceDelete)
      setAttendanceView(getRoleByIDData.attendanceView)
      setAttendanceUpload(getRoleByIDData.attendanceUpload)
      setAttendanceUpdate(getRoleByIDData.attendanceUpdate)
      setAttendanceDelete(getRoleByIDData.attendanceDelete)
      setAttendanceStats(getRoleByIDData.attendanceStats)
      setBonusMaster(getRoleByIDData.bonusMaster)
      setExportBankSheet(getRoleByIDData.exportBankSheet)
      setSalaryApproval(getRoleByIDData.salaryApproval)
      setAccessCollectionType(getRoleByIDData.accessCollectionType)
      setAccessVerificationType(getRoleByIDData.accessVerificationType)
      setAccessStandardType(getRoleByIDData.accessStandardType)
      setSupervisorMasterView(getRoleByIDData.supervisorMasterView)
      setSupervisorMasterAdd(getRoleByIDData.supervisorMasterAdd)
      setSupervisorMasterUpdate(getRoleByIDData.supervisorMasterUpdate)
      setSupervisorMasterDelete(getRoleByIDData.supervisorMasterDelete)
      setBillingMasterView(getRoleByIDData.billingMasterView)
      setBillingMasterAdd(getRoleByIDData.billingMasterAdd)
      setBillingMasterUpdate(getRoleByIDData.billingMasterUpdate)
      setBillingMasterDelete(getRoleByIDData.billingMasterDelete)
      setBillingMasterStatusUpdate(getRoleByIDData.billingMasterStatusUpdate)
      setProvisionalBillingView(getRoleByIDData.provisionalBillingView)
      setProvisionalBillingSubmit(getRoleByIDData.provisionalBillingSubmit)
      setProvisionalBillingUpdate(getRoleByIDData.provisionalBillingUpdate)
      setProvisionalBillingFillOnBehalf(getRoleByIDData.provisionalBillingFillOnBehalf)
      setDistributionView(getRoleByIDData.distributionView)
      setDistributionAdd(getRoleByIDData.distributionAdd)
      setDistributionUpdate(getRoleByIDData.distributionUpdate)
      setCollectionMisView(getRoleByIDData.collectionMisView)
      setCollectionMisOverridePaid(getRoleByIDData.collectionMisOverridePaid)
      setEmployeeMasterView(getRoleByIDData.employeeMasterView)
      setEmployeeMasterAdd(getRoleByIDData.employeeMasterAdd)
      setEmployeeMasterUpdate(getRoleByIDData.employeeMasterUpdate)
      setEmployeeMasterDelete(getRoleByIDData.employeeMasterDelete)
      setEmployeeMasterMarkLeft(getRoleByIDData.employeeMasterMarkLeft)
      setEmployeeMasterUpload(getRoleByIDData.employeeMasterUpload)
      setEmployeeLeftView(getRoleByIDData.employeeLeftView)
      setEmployeeLeftAdd(getRoleByIDData.employeeLeftAdd)
      setEmployeeLeftUpdate(getRoleByIDData.employeeLeftUpdate)
      setEmployeeLeftDelete(getRoleByIDData.employeeLeftDelete)
      setEmployeeLeftRejoin(getRoleByIDData.employeeLeftRejoin)
      setEmployeeLeftUpload(getRoleByIDData.employeeLeftUpload)
      setAdvanceCurrentMonthOnly(getRoleByIDData.advanceCurrentMonthOnly)
      setAttendanceCurrentMonthOnly(getRoleByIDData.attendanceCurrentMonthOnly)
      setBonusCurrentMonthOnly(getRoleByIDData.bonusCurrentMonthOnly)
      setPriceMasterView(getRoleByIDData.priceMasterView)
      setPriceMasterImport(getRoleByIDData.priceMasterImport)
      setPriceMasterDelete(getRoleByIDData.priceMasterDelete)
      setReimbursementMasterView(getRoleByIDData.reimbursementMasterView)
      setReimbursementMasterImport(getRoleByIDData.reimbursementMasterImport)
      setReimbursementMasterDelete(getRoleByIDData.reimbursementMasterDelete)
      setCaseMasterView(getRoleByIDData.caseMasterView)
      setCaseMasterImport(getRoleByIDData.caseMasterImport)
      setCaseMasterDelete(getRoleByIDData.caseMasterDelete)
      setPenaltyMasterView(getRoleByIDData.penaltyMasterView)
      setPenaltyMasterImport(getRoleByIDData.penaltyMasterImport)
      setPenaltyMasterDelete(getRoleByIDData.penaltyMasterDelete)
      setConveyanceMasterView(getRoleByIDData.conveyanceMasterView)
      setConveyanceMasterImport(getRoleByIDData.conveyanceMasterImport)
      setConveyanceMasterDelete(getRoleByIDData.conveyanceMasterDelete)
      setVerificationReportView(getRoleByIDData.verificationReportView)
      setVerificationReportGenerate(getRoleByIDData.verificationReportGenerate)
      setVerificationReportExport(getRoleByIDData.verificationReportExport)
      setVerificationReportEdit(getRoleByIDData.verificationReportEdit)
      setConsolidatedMisView(getRoleByIDData.consolidatedMisView)
      setConsolidatedMisExport(getRoleByIDData.consolidatedMisExport)

    } else if (errorGetRoleByIDInfo) {
      setLoading(false)
      if (errorGetRoleByIDInfo.includes('Cast')) {
        navigate('/')
        return
      }
      toast(errorGetRoleByIDInfo, {
        type: 'error',
        hideProgressBar: true,
        autoClose: 2000,
      })
    }
  }, [getRoleByIDData, errorGetRoleByIDInfo])

  // * Update Role
  const updateRoleHandler = () => {
    if (id === '') {
      toast('Role ID is mandatory', {
        type: 'error',
        hideProgressBar: true,
        autoClose: 2000,
      })
    } else {
      dispatch(
        updateRole(
          id,
          tasksView,
          tasksDetailsView,
          tasksUpdate,
          tasksAddCustomer,
          tasksAddAllocation,
          allocationPendingTasks,
          visitPendingTasks,
          inProgressTasks,
          finalisationPendingTasks,
          completedTasks,
          waivedTasks,
          calling,
          taskSummary,
          transfers,
          usersView,
          usersAdd,
          usersUpdate,
          viewAttendance,
          rejoinUsers,
          viewUnassignTasks,
          viewTransfferedTasks,
          viewFieldTasks,
          resignedUsers,
          rolesView,
          rolesAdd,
          rolesUpdate,
          customersView,
          customersAdd,
          customersUpdate,
          appAccess,
          webAccess,
          settings,
          reports,
          pincodes,
          dashboard,
          processView,
          processAdd,
          ProcessUpdate,
          ProcessDelete,
          assignProcessView,
          assignProcessAdd,
          assignProcessUpdate,
          assignProcessDelete,
          DailyCollectionView,
          DailyCollectionViewAdd,
          DailyCollectionViewUpdate,
          DailyCollectionViewDelete,
          mis,
          driveNbfcDelhi,
          driveNbfcHaryana,
          driveNbfcUp,
          driveNbfcTata,
          driveHdfcCard,
          driveHdfcRetail,
          driveIdfc,
          driveKotak,
          verificationProcessView,
          verificationProcessAdd,
          verificationProcessUpdate,
          verificationProcessDelete,
          assignVerificationProcessView,
          assignVerificationProcessAdd,
          assignVerificationProcessUpdate,
          assignVerificationProcessDelete,
          verificationMisAdd,
          verificationMisUpdate,
          verificationMisDelete,
          verificationMisView,
          verificationMisReport,
          driveHdfcCardUp,
          driveHdfcRetailUp,
          exportRole,
          prospectForm,
          companyView,
          companyAdd,
          companyUpdate,
          companyDelete,
          salaryView,
          salaryUpload,
          salaryUpdate,
          salaryDelete,
          salaryStats,
          advanceView,
          advanceUpload,
          advanceUpdate,
          advanceDelete,
          attendanceView,
          attendanceUpload,
          attendanceUpdate,
          attendanceDelete,
          attendanceStats,
          bonusMaster,
          exportBankSheet,
          salaryApproval,
          accessCollectionType,
          accessVerificationType,
          accessStandardType,
          supervisorMasterView,
          supervisorMasterAdd,
          supervisorMasterUpdate,
          supervisorMasterDelete,
          billingMasterView,
          billingMasterAdd,
          billingMasterUpdate,
          billingMasterDelete,
          billingMasterStatusUpdate,
          provisionalBillingView,
          provisionalBillingSubmit,
          provisionalBillingUpdate,
          provisionalBillingFillOnBehalf,
          distributionView,
          distributionAdd,
          distributionUpdate,
          collectionMisView,
          collectionMisOverridePaid,
          employeeMasterView,
          employeeMasterAdd,
          employeeMasterUpdate,
          employeeMasterDelete,
          employeeMasterMarkLeft,
          employeeMasterUpload,
          employeeLeftView,
          employeeLeftAdd,
          employeeLeftUpdate,
          employeeLeftDelete,
          employeeLeftRejoin,
          employeeLeftUpload,
          advanceCurrentMonthOnly,
          attendanceCurrentMonthOnly,
          bonusCurrentMonthOnly,
          priceMasterView,
          priceMasterImport,
          priceMasterDelete,
          reimbursementMasterView,
          reimbursementMasterImport,
          reimbursementMasterDelete,
          caseMasterView,
          caseMasterImport,
          caseMasterDelete,
          penaltyMasterView,
          penaltyMasterImport,
          penaltyMasterDelete,
          conveyanceMasterView,
          conveyanceMasterImport,
          conveyanceMasterDelete,
          verificationReportView,
          verificationReportGenerate,
          verificationReportExport,
          verificationReportEdit,
          consolidatedMisView,
          consolidatedMisExport
        )
      )
    }
  }

  const updateRoleInfo = useSelector((state) => state.updateRoleInfo)
  const { loadingUpdateRoleInfo, errorUpdateRoleInfo, updateRoleData } =
    updateRoleInfo

  useEffect(() => {
    dispatch({ type: UPDATE_ROLE_RESET })
    if (updateRoleData) {
      toast('Role updated successfully', {
        type: 'success',
        hideProgressBar: true,
        autoClose: 2000,
      })
      setTimeout(() => {
        navigate('/roles')
      }, 1000)
    } else if (errorUpdateRoleInfo) {
      toast(errorUpdateRoleInfo, {
        type: 'error',
        hideProgressBar: true,
        autoClose: 2000,
      })
    }
  }, [updateRoleData, errorUpdateRoleInfo])

  if (loading) {
    return <Loading />
  }

  return (
    <div className='w-full h-full'>
      <h1 className='text-2xl font-semibold'>Add Role</h1>
      <div className='bg-white shadow-md rounded px-8 py-8 my-4'>
        <h3 className='text-md font-semibold mb-2'>Name</h3>
        <Input
          name='Name'
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled
        />
        <h3 className='text-md font-semibold mt-8'>Tasks</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true ? setTasksView(true) : noTasksView()
              }
              checked={tasksView === true ? true : false}
            />
            <span class='text-sm'>View Tasks</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setTasksDetailsView(true)
                  : setTasksDetailsView(false)
              }
              checked={tasksDetailsView === true ? true : false}
            />
            <span class='text-sm'>View Tasks Details</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setTasksUpdate(true)
                  : setTasksUpdate(false)
              }
              checked={tasksUpdate === true ? true : false}
            />
            <span class='text-sm'>Update Tasks</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? tasksAddByCustomer()
                  : setTasksAddCustomer(false)
              }
              checked={tasksAddCustomer === true ? true : false}
            />
            <span class='text-sm'>Tasks Add By Customer</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? tasksAddByAllocator()
                  : setTasksAddAllocation(false)
              }
              checked={tasksAddAllocation === true ? true : false}
            />
            <span class='text-sm'>Tasks Add By Allocator</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAllocationPendingTasks(true)
                  : setAllocationPendingTasks(false)
              }
              checked={allocationPendingTasks === true ? true : false}
            />
            <span class='text-sm'>View Allocation Pending Tasks</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVisitPendingTasks(true)
                  : setVisitPendingTasks(false)
              }
              checked={visitPendingTasks === true ? true : false}
            />
            <span class='text-sm'>View Visit Pending Tasks</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setInProgressTasks(true)
                  : setInProgressTasks(false)
              }
              checked={inProgressTasks === true ? true : false}
            />
            <span class='text-sm'>View In Progress Tasks</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setFinalisationPendingTasks(true)
                  : setFinalisationPendingTasks(false)
              }
              checked={finalisationPendingTasks === true ? true : false}
            />
            <span class='text-sm'>View Finalisation Pending Tasks</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setCompletedTasks(true)
                  : setCompletedTasks(false)
              }
              checked={completedTasks === true ? true : false}
            />
            <span class='text-sm'>View Completed Tasks</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setWaivedTasks(true)
                  : setWaivedTasks(false)
              }
              checked={waivedTasks === true ? true : false}
            />
            <span class='text-sm'>View Waived Tasks</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true ? setCalling(true) : setCalling(false)
              }
              checked={calling === true ? true : false}
            />
            <span class='text-sm'>Calling</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setTaskSummary(true)
                  : setTaskSummary(false)
              }
              checked={taskSummary === true ? true : false}
            />
            <span class='text-sm'>Task Summary</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setTransfers(true)
                  : setTransfers(false)
              }
              checked={transfers === true ? true : false}
            />
            <span class='text-sm'>Transfers</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setViewUnassignTasks(true)
                  : setViewUnassignTasks(false)
              }
              checked={viewUnassignTasks === true ? true : false}
            />
            <span class='text-sm'>UnAssigned Task View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setViewFieldTasks(true)
                  : setViewFieldTasks(false)
              }
              checked={viewFieldTasks === true ? true : false}
            />
            <span class='text-sm'>Field Taks View</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Process Management</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setProcessView(true)
                  : setProcessView(false)
              }
              checked={processView === true ? true : false}
            />
            <span class='text-sm'>Process View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setProcessAdd(true)
                  : setProcessAdd(false)
              }
              checked={processAdd === true ? true : false}
            />
            <span class='text-sm'>Process Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setProcessUpdate(true)
                  : setProcessUpdate(false)
              }
              checked={ProcessUpdate === true ? true : false}
            />
            <span class='text-sm'>Process Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setProcessDelete(true)
                  : setProcessDelete(false)
              }
              checked={ProcessDelete === true ? true : false}
            />
            <span class='text-sm'>Process Delete</span>
          </label>
        </div>

        <h3 className='text-md font-semibold mt-8'>Assign Process</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAssignProcessView(true)
                  : setAssignProcessView(false)
              }
              checked={assignProcessView === true ? true : false}
            />
            <span class='text-sm'>Assign Process View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAssignProcessAdd(true)
                  : setAssignProcessAdd(false)
              }
              checked={assignProcessAdd === true ? true : false}
            />
            <span class='text-sm'>Assign Process Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAssignProcessUpdate(true)
                  : setAssignProcessUpdate(false)
              }
              checked={assignProcessUpdate === true ? true : false}
            />
            <span class='text-sm'>Assign Process Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAssignProcessDelete(true)
                  : setAssignProcessDelete(false)
              }
              checked={assignProcessDelete === true ? true : false}
            />
            <span class='text-sm'>Assign Process Delete</span>
          </label>
        </div>

        <h3 className='text-md font-semibold mt-8'>Daily Collection</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDailyCollectionView(true)
                  : setDailyCollectionView(false)
              }
              checked={DailyCollectionView === true ? true : false}
            />
            <span class='text-sm'>Daily Collection View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDailyCollectionViewAdd(true)
                  : setDailyCollectionViewAdd(false)
              }
              checked={DailyCollectionViewAdd === true ? true : false}
            />
            <span class='text-sm'>Daily Collection Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDailyCollectionViewUpdate(true)
                  : setDailyCollectionViewUpdate(false)
              }
              checked={DailyCollectionViewUpdate === true ? true : false}
            />
            <span class='text-sm'>Daily Collection Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDailyCollectionViewDelete(true)
                  : setDailyCollectionViewDelete(false)
              }
              checked={DailyCollectionViewDelete === true ? true : false}
            />
            <span class='text-sm'>Daily Collection Delete</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Users</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setUsersView(true)
                  : setUsersView(false)
              }
              checked={usersView === true ? true : false}
            />
            <span class='text-sm'>View Users</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setUsersAdd(true)
                  : setUsersAdd(false)
              }
              checked={usersAdd === true ? true : false}
            />
            <span class='text-sm'>Add Users</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setUsersUpdate(true)
                  : setUsersUpdate(false)
              }
              checked={usersUpdate === true ? true : false}
            />
            <span class='text-sm'>Update Users</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setRejoinUsers(true)
                  : setRejoinUsers(false)
              }
              checked={rejoinUsers === true ? true : false}
            />
            <span class='text-sm'>Rejoin Users</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setResignedUsers(true)
                  : setResignedUsers(false)
              }
              checked={resignedUsers === true ? true : false}
            />
            <span class='text-sm'>Resigned Users</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Roles</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setRolesView(true)
                  : setRolesView(false)
              }
              checked={rolesView === true ? true : false}
            />
            <span class='text-sm'>View Roles</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setRolesAdd(true)
                  : setRolesAdd(false)
              }
              checked={rolesAdd === true ? true : false}
            />
            <span class='text-sm'>Add Roles</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setRolesUpdate(true)
                  : setRolesUpdate(false)
              }
              checked={rolesUpdate === true ? true : false}
            />
            <span class='text-sm'>Update Roles</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Customers</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setCustomersView(true)
                  : setCustomersView(false)
              }
              checked={customersView === true ? true : false}
            />
            <span class='text-sm'>View Customers</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setCustomersAdd(true)
                  : setCustomersAdd(false)
              }
              checked={customersAdd === true ? true : false}
            />
            <span class='text-sm'>Add Customers</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setCustomersUpdate(true)
                  : setCustomersUpdate(false)
              }
              checked={customersUpdate === true ? true : false}
            />
            <span class='text-sm'>Update Customers</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Drive Access</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveNbfcDelhi(true)
                  : setDriveNbfcDelhi(false)
              }
              checked={driveNbfcDelhi === true ? true : false}
            />
            <span class='text-sm'>NBFC Delhi</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveNbfcHaryana(true)
                  : setDriveNbfcHaryana(false)
              }
              checked={driveNbfcHaryana === true ? true : false}
            />
            <span class='text-sm'>NBFC Haryana</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveNbfcUp(true)
                  : setDriveNbfcUp(false)
              }
              checked={driveNbfcUp === true ? true : false}
            />
            <span class='text-sm'>NBFC UP</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveNbfcTata(true)
                  : setDriveNbfcTata(false)
              }
              checked={driveNbfcTata === true ? true : false}
            />
            <span class='text-sm'>NBFC Tata</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveHdfcCard(true)
                  : setDriveHdfcCard(false)
              }
              checked={driveHdfcCard === true ? true : false}
            />
            <span class='text-sm'>HDFC Card</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveHdfcCardUp(true)
                  : setDriveHdfcCardUp(false)
              }
              checked={driveHdfcCardUp === true ? true : false}
            />
            <span class='text-sm'>HDFC Card UP</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveHdfcRetailUp(true)
                  : setDriveHdfcRetailUp(false)
              }
              checked={driveHdfcRetailUp === true ? true : false}
            />
            <span class='text-sm'>HDFC Retail UP</span>
          </label>

          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveHdfcRetail(true)
                  : setDriveHdfcRetail(false)
              }
              checked={driveHdfcRetail === true ? true : false}
            />
            <span class='text-sm'>HDFC Retail</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveIdfc(true)
                  : setDriveIdfc(false)
              }
              checked={driveIdfc === true ? true : false}
            />
            <span class='text-sm'>IDFC </span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDriveKotak(true)
                  : setDriveKotak(false)
              }
              checked={driveKotak === true ? true : false}
            />
            <span class='text-sm'>Kotak </span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Verification Process</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationProcessView(true)
                  : setVerificationProcessView(false)
              }
              checked={verificationProcessView === true ? true : false}
            />
            <span class='text-sm'>Verification Process View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationProcessAdd(true)
                  : setVerificationProcessAdd(false)
              }
              checked={verificationProcessAdd === true ? true : false}
            />
            <span class='text-sm'>Verification Process Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationProcessUpdate(true)
                  : setVerificationProcessUpdate(false)
              }
              checked={verificationProcessUpdate === true ? true : false}
            />
            <span class='text-sm'>Verification Process Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationProcessDelete(true)
                  : setVerificationProcessDelete(false)
              }
              checked={verificationProcessDelete === true ? true : false}
            />
            <span class='text-sm'>Verification Process Delete</span>
          </label>
        </div>

        <h3 className='text-md font-semibold mt-8'>Assign Verification Process</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAssignVerificationProcessView(true)
                  : setAssignVerificationProcessView(false)
              }
              checked={assignVerificationProcessView === true ? true : false}
            />
            <span class='text-sm'>Assign Verification Process View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAssignVerificationProcessAdd(true)
                  : setAssignVerificationProcessAdd(false)
              }
              checked={assignVerificationProcessAdd === true ? true : false}
            />
            <span class='text-sm'>Assign Verification Process Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAssignVerificationProcessUpdate(true)
                  : setAssignVerificationProcessUpdate(false)
              }
              checked={assignVerificationProcessUpdate === true ? true : false}
            />
            <span class='text-sm'>Assign Verification Process Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAssignVerificationProcessDelete(true)
                  : setAssignVerificationProcessDelete(false)
              }
              checked={assignVerificationProcessDelete === true ? true : false}
            />
            <span class='text-sm'>Assign Verification Process Delete</span>
          </label>
        </div>

        <h3 className='text-md font-semibold mt-8'>Verification MIS</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationMisView(true)
                  : setVerificationMisView(false)
              }
              checked={verificationMisView === true ? true : false}
            />
            <span class='text-sm'>Verification MIS View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationMisAdd(true)
                  : setVerificationMisAdd(false)
              }
              checked={verificationMisAdd === true ? true : false}
            />
            <span class='text-sm'>Verification MIS Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationMisUpdate(true)
                  : setVerificationMisUpdate(false)
              }
              checked={verificationMisUpdate === true ? true : false}
            />
            <span class='text-sm'>Verification MIS Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationMisDelete(true)
                  : setVerificationMisDelete(false)
              }
              checked={verificationMisDelete === true ? true : false}
            />
            <span class='text-sm'>Verification MIS Delete</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setVerificationMisReport(true)
                  : setVerificationMisReport(false)
              }
              checked={verificationMisReport === true ? true : false}
            />
            <span class='text-sm'>Verification MIS Report</span>
          </label>
        </div>

        <h3 className='text-md font-semibold mt-8'>Login Access</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAppAccess(true)
                  : setAppAccess(false)
              }
              checked={appAccess === true ? true : false}
            />
            <span class='text-sm'>App Access</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setWebAccess(true)
                  : setWebAccess(false)
              }
              checked={webAccess === true ? true : false}
            />
            <span class='text-sm'>Web Access</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Settings</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSettings(true)
                  : setSettings(false)
              }
              checked={settings === true ? true : false}
            />
            <span class='text-sm'>Settings</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true ? setReports(true) : setReports(false)
              }
              checked={reports === true ? true : false}
            />
            <span class='text-sm'>Reports</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setViewAttendance(true)
                  : setViewAttendance(false)
              }
              checked={viewAttendance === true ? true : false}
            />
            <span class='text-sm'>View Attendance</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setPincodes(true)
                  : setPincodes(false)
              }
              checked={pincodes === true ? true : false}
            />
            <span class='text-sm'>Pincodes</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setDashboard(true)
                  : setDashboard(false)
              }
              checked={dashboard === true ? true : false}
            />
            <span class='text-sm'>Dashboard</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true ? setMis(true) : setMis(false)
              }
              checked={mis === true ? true : false}
            />
            <span class='text-sm'>MIS Access</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setExportRole(true)
                  : setExportRole(false)
              }
              checked={exportRole === true ? true : false}
            />
            <span class='text-sm'>Export</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setProspectForm(true)
                  : setProspectForm(false)
              }
              checked={prospectForm === true ? true : false}
            />
            <span class='text-sm'>Prospect Form</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Salary Management</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setCompanyView(true)
                  : setCompanyView(false)
              }
              checked={companyView === true ? true : false}
            />
            <span class='text-sm'>Company View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setCompanyAdd(true)
                  : setCompanyAdd(false)
              }
              checked={companyAdd === true ? true : false}
            />
            <span class='text-sm'>Company Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setCompanyUpdate(true)
                  : setCompanyUpdate(false)
              }
              checked={companyUpdate === true ? true : false}
            />
            <span class='text-sm'>Company Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setCompanyDelete(true)
                  : setCompanyDelete(false)
              }
              checked={companyDelete === true ? true : false}
            />
            <span class='text-sm'>Company Delete</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSalaryView(true)
                  : setSalaryView(false)
              }
              checked={salaryView === true ? true : false}
            />
            <span class='text-sm'>Salary View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSalaryUpload(true)
                  : setSalaryUpload(false)
              }
              checked={salaryUpload === true ? true : false}
            />
            <span class='text-sm'>Salary Upload</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSalaryUpdate(true)
                  : setSalaryUpdate(false)
              }
              checked={salaryUpdate === true ? true : false}
            />
            <span class='text-sm'>Salary Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSalaryDelete(true)
                  : setSalaryDelete(false)
              }
              checked={salaryDelete === true ? true : false}
            />
            <span class='text-sm'>Salary Delete</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSalaryStats(true)
                  : setSalaryStats(false)
              }
              checked={salaryStats === true ? true : false}
            />
            <span class='text-sm'>Salary Statistics</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSalaryApproval(true)
                  : setSalaryApproval(false)
              }
              checked={salaryApproval === true ? true : false}
            />
            <span class='text-sm'>Salary Approval</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAdvanceView(true)
                  : setAdvanceView(false)
              }
              checked={advanceView === true ? true : false}
            />
            <span class='text-sm'>Advance View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAdvanceUpload(true)
                  : setAdvanceUpload(false)
              }
              checked={advanceUpload === true ? true : false}
            />
            <span class='text-sm'>Advance Upload</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAdvanceUpdate(true)
                  : setAdvanceUpdate(false)
              }
              checked={advanceUpdate === true ? true : false}
            />
            <span class='text-sm'>Advance Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAdvanceDelete(true)
                  : setAdvanceDelete(false)
              }
              checked={advanceDelete === true ? true : false}
            />
            <span class='text-sm'>Advance Delete</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAttendanceView(true)
                  : setAttendanceView(false)
              }
              checked={attendanceView === true ? true : false}
            />
            <span class='text-sm'>Attendance View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAttendanceUpload(true)
                  : setAttendanceUpload(false)
              }
              checked={attendanceUpload === true ? true : false}
            />
            <span class='text-sm'>Attendance Upload</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAttendanceUpdate(true)
                  : setAttendanceUpdate(false)
              }
              checked={attendanceUpdate === true ? true : false}
            />
            <span class='text-sm'>Attendance Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAttendanceDelete(true)
                  : setAttendanceDelete(false)
              }
              checked={attendanceDelete === true ? true : false}
            />
            <span class='text-sm'>Attendance Delete</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAttendanceStats(true)
                  : setAttendanceStats(false)
              }
              checked={attendanceStats === true ? true : false}
            />
            <span class='text-sm'>Attendance Statistics</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setBonusMaster(true)
                  : setBonusMaster(false)
              }
              checked={bonusMaster === true ? true : false}
            />
            <span class='text-sm'>Bonus Master</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setExportBankSheet(true)
                  : setExportBankSheet(false)
              }
              checked={exportBankSheet === true ? true : false}
            />
            <span class='text-sm'>Export Bank Sheet</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Salary Type Access</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAccessCollectionType(true)
                  : setAccessCollectionType(false)
              }
              checked={accessCollectionType === true ? true : false}
            />
            <span class='text-sm'>Collection Type Access</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAccessVerificationType(true)
                  : setAccessVerificationType(false)
              }
              checked={accessVerificationType === true ? true : false}
            />
            <span class='text-sm'>Verification Type Access</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setAccessStandardType(true)
                  : setAccessStandardType(false)
              }
              checked={accessStandardType === true ? true : false}
            />
            <span class='text-sm'>Standard Type Access</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Supervisor's Master</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSupervisorMasterView(true)
                  : setSupervisorMasterView(false)
              }
              checked={supervisorMasterView === true ? true : false}
            />
            <span class='text-sm'>Supervisor Master View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSupervisorMasterAdd(true)
                  : setSupervisorMasterAdd(false)
              }
              checked={supervisorMasterAdd === true ? true : false}
            />
            <span class='text-sm'>Supervisor Master Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSupervisorMasterUpdate(true)
                  : setSupervisorMasterUpdate(false)
              }
              checked={supervisorMasterUpdate === true ? true : false}
            />
            <span class='text-sm'>Supervisor Master Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) =>
                e.target.checked === true
                  ? setSupervisorMasterDelete(true)
                  : setSupervisorMasterDelete(false)
              }
              checked={supervisorMasterDelete === true ? true : false}
            />
            <span class='text-sm'>Supervisor Master Delete</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Billing Master</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setBillingMasterView(true) : setBillingMasterView(false)}
              checked={billingMasterView === true ? true : false}
            />
            <span class='text-sm'>Billing Master View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setBillingMasterAdd(true) : setBillingMasterAdd(false)}
              checked={billingMasterAdd === true ? true : false}
            />
            <span class='text-sm'>Billing Master Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setBillingMasterUpdate(true) : setBillingMasterUpdate(false)}
              checked={billingMasterUpdate === true ? true : false}
            />
            <span class='text-sm'>Billing Master Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setBillingMasterDelete(true) : setBillingMasterDelete(false)}
              checked={billingMasterDelete === true ? true : false}
            />
            <span class='text-sm'>Billing Master Delete</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setBillingMasterStatusUpdate(true) : setBillingMasterStatusUpdate(false)}
              checked={billingMasterStatusUpdate === true ? true : false}
            />
            <span class='text-sm'>Billing Master Status Update</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Provisional Billing</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setProvisionalBillingView(true) : setProvisionalBillingView(false)}
              checked={provisionalBillingView === true ? true : false}
            />
            <span class='text-sm'>Provisional Billing View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setProvisionalBillingSubmit(true) : setProvisionalBillingSubmit(false)}
              checked={provisionalBillingSubmit === true ? true : false}
            />
            <span class='text-sm'>Provisional Billing Submit</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setProvisionalBillingUpdate(true) : setProvisionalBillingUpdate(false)}
              checked={provisionalBillingUpdate === true ? true : false}
            />
            <span class='text-sm'>Provisional Billing Update</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setProvisionalBillingFillOnBehalf(true) : setProvisionalBillingFillOnBehalf(false)}
              checked={provisionalBillingFillOnBehalf === true ? true : false}
            />
            <span class='text-sm'>Provisional Billing Fill On Behalf (from Billing Master)</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Distribution</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setDistributionView(true) : setDistributionView(false)}
              checked={distributionView === true ? true : false}
            />
            <span class='text-sm'>Distribution View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setDistributionAdd(true) : setDistributionAdd(false)}
              checked={distributionAdd === true ? true : false}
            />
            <span class='text-sm'>Distribution Add</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setDistributionUpdate(true) : setDistributionUpdate(false)}
              checked={distributionUpdate === true ? true : false}
            />
            <span class='text-sm'>Distribution Update</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Collection MIS</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setCollectionMisView(true) : setCollectionMisView(false)}
              checked={collectionMisView === true ? true : false}
            />
            <span class='text-sm'>Collection MIS View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input
              class='mr-2 leading-tight'
              type='checkbox'
              onChange={(e) => e.target.checked === true ? setCollectionMisOverridePaid(true) : setCollectionMisOverridePaid(false)}
              checked={collectionMisOverridePaid === true ? true : false}
            />
            <span class='text-sm'>Collection MIS Override Paid Status</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Employee Master - Active Employees</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeMasterView(e.target.checked)}
              checked={employeeMasterView} />
            <span class='text-sm'>View Active Employees</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeMasterAdd(e.target.checked)}
              checked={employeeMasterAdd} />
            <span class='text-sm'>Add Employee</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeMasterUpdate(e.target.checked)}
              checked={employeeMasterUpdate} />
            <span class='text-sm'>Update Employee</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeMasterDelete(e.target.checked)}
              checked={employeeMasterDelete} />
            <span class='text-sm'>Delete Employee</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeMasterMarkLeft(e.target.checked)}
              checked={employeeMasterMarkLeft} />
            <span class='text-sm'>Mark as Left</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeMasterUpload(e.target.checked)}
              checked={employeeMasterUpload} />
            <span class='text-sm'>Upload Employees</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Employee Master - Left Employees</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeLeftView(e.target.checked)}
              checked={employeeLeftView} />
            <span class='text-sm'>View Left Employees</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeLeftAdd(e.target.checked)}
              checked={employeeLeftAdd} />
            <span class='text-sm'>Add Left Employee</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeLeftUpdate(e.target.checked)}
              checked={employeeLeftUpdate} />
            <span class='text-sm'>Update Left Employee</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeLeftDelete(e.target.checked)}
              checked={employeeLeftDelete} />
            <span class='text-sm'>Delete Left Employee</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeLeftRejoin(e.target.checked)}
              checked={employeeLeftRejoin} />
            <span class='text-sm'>Rejoin Employee</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setEmployeeLeftUpload(e.target.checked)}
              checked={employeeLeftUpload} />
            <span class='text-sm'>Upload Left Employees</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Current Month Only Restrictions</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setAdvanceCurrentMonthOnly(e.target.checked)}
              checked={advanceCurrentMonthOnly} />
            <span class='text-sm'>Advance - Current Month Only</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setAttendanceCurrentMonthOnly(e.target.checked)}
              checked={attendanceCurrentMonthOnly} />
            <span class='text-sm'>Attendance - Current Month Only</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setBonusCurrentMonthOnly(e.target.checked)}
              checked={bonusCurrentMonthOnly} />
            <span class='text-sm'>Bonus - Current Month Only</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Price Master</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setPriceMasterView(e.target.checked)}
              checked={priceMasterView} />
            <span class='text-sm'>Price Master View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setPriceMasterImport(e.target.checked)}
              checked={priceMasterImport} />
            <span class='text-sm'>Price Master Import</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setPriceMasterDelete(e.target.checked)}
              checked={priceMasterDelete} />
            <span class='text-sm'>Price Master Delete</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Reimbursement Master</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setReimbursementMasterView(e.target.checked)}
              checked={reimbursementMasterView} />
            <span class='text-sm'>Reimbursement Master View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setReimbursementMasterImport(e.target.checked)}
              checked={reimbursementMasterImport} />
            <span class='text-sm'>Reimbursement Master Import</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setReimbursementMasterDelete(e.target.checked)}
              checked={reimbursementMasterDelete} />
            <span class='text-sm'>Reimbursement Master Delete</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Case Master</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setCaseMasterView(e.target.checked)}
              checked={caseMasterView} />
            <span class='text-sm'>Case Master View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setCaseMasterImport(e.target.checked)}
              checked={caseMasterImport} />
            <span class='text-sm'>Case Master Import</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setCaseMasterDelete(e.target.checked)}
              checked={caseMasterDelete} />
            <span class='text-sm'>Case Master Delete</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Penalty Master</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setPenaltyMasterView(e.target.checked)}
              checked={penaltyMasterView} />
            <span class='text-sm'>Penalty Master View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setPenaltyMasterImport(e.target.checked)}
              checked={penaltyMasterImport} />
            <span class='text-sm'>Penalty Master Import</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setPenaltyMasterDelete(e.target.checked)}
              checked={penaltyMasterDelete} />
            <span class='text-sm'>Penalty Master Delete</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Conveyance Master</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setConveyanceMasterView(e.target.checked)}
              checked={conveyanceMasterView} />
            <span class='text-sm'>Conveyance Master View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setConveyanceMasterImport(e.target.checked)}
              checked={conveyanceMasterImport} />
            <span class='text-sm'>Conveyance Master Import</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setConveyanceMasterDelete(e.target.checked)}
              checked={conveyanceMasterDelete} />
            <span class='text-sm'>Conveyance Master Delete</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Verification Report</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setVerificationReportView(e.target.checked)}
              checked={verificationReportView} />
            <span class='text-sm'>Verification Report View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setVerificationReportGenerate(e.target.checked)}
              checked={verificationReportGenerate} />
            <span class='text-sm'>Generate Report</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setVerificationReportExport(e.target.checked)}
              checked={verificationReportExport} />
            <span class='text-sm'>Export Report</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold mt-6'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setVerificationReportEdit(e.target.checked)}
              checked={verificationReportEdit} />
            <span class='text-sm'>Edit Report</span>
          </label>
        </div>
        <h3 className='text-md font-semibold mt-8'>Consolidated MIS</h3>
        <div class='flex flex-wrap md:items-center mt-4'>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setConsolidatedMisView(e.target.checked)}
              checked={consolidatedMisView} />
            <span class='text-sm'>Consolidated MIS View</span>
          </label>
          <label class='w-1/3 text-gray-500 font-bold'>
            <input class='mr-2 leading-tight' type='checkbox'
              onChange={(e) => setConsolidatedMisExport(e.target.checked)}
              checked={consolidatedMisExport} />
            <span class='text-sm'>Consolidated MIS Export</span>
          </label>
        </div>
        <Button
          type='button'
          text='Update'
          custom='mt-6 py-2 px-6'
          onClick={updateRoleHandler}
        />
      </div>
    </div>
  )
}

export default RoleByID